import { Schema } from "effect";

export const CONVERSATION_PRODUCTS = [
  "support",
  "shopper_ai",
  "recover",
  "marketing",
] as const;

export const ConversationProduct = Schema.Literal(...CONVERSATION_PRODUCTS);
export type ConversationProduct = typeof ConversationProduct.Type;
